const CylinderType = {
    recovery : 0,
    reclaimed : 2
};

export default CylinderType;